import axios from '@/api/axios'
import COMMON_ENV from '@/config/env'
import { replaceCode } from '@/assets/utils/util'

// 后台接口url
const BASE_URL = '/fatsapi/lawsinfo-website'
// 前端域名(重定向用)
// const normalUrl = '/lawsinfo-website/index.html'

export default {
  // 用于生成h5二维码地址
  qrLink() {
    const url = COMMON_ENV.lawsinfo_url // 域名
    const PROJECT_NAME_H5 = COMMON_ENV.PROJECT_NAME_H5 // h5项目名称
    const PROJECT_NAME_WEB = COMMON_ENV.PROJECT_NAME_WEB // web项目名称
    return [url, PROJECT_NAME_H5, PROJECT_NAME_WEB]
  },
  // 登录注册
  login(type, path) {
    const REDIRECT_URI = encodeURIComponent(replaceCode(path))
    // 去登录页 去登录的时候本地缓存 REDIRECT_URI 获取token传参无需编码，直接存href
    window.localStorage.setItem('REDIRECT_URI', replaceCode(path))

    let url = `/uoauth/authorize?client_id=${COMMON_ENV.CLIENT_ID}&response_type=code&redirect_uri=${REDIRECT_URI}`

    if (type === 'reg') {
      // 注册 register
      url = `/uoauth/authorize?page=register&client_id=${COMMON_ENV.CLIENT_ID}&response_type=code&redirect_uri=${REDIRECT_URI}`
    }
    window.location.href = COMMON_ENV.SSO_URL + url
  },

  // 退出登录
  loginout() {
    const REDIRECT_URI = encodeURIComponent(replaceCode())
    window.localStorage.setItem('REDIRECT_URI', replaceCode())
    const url = `/uauthentication/h5/logout?redirect_uri=${REDIRECT_URI}`
    window.location.href = COMMON_ENV.SSO_URL + url
  },

  getToken(params) {
    const url = '/uauthentication/oauth/token'
    // // 获取token 从本地获取上一次REDIRECT_URI
    const formData = {
      client_id: COMMON_ENV.CLIENT_ID, // 为COMMON_ENV.CLIENT_ID:secret，分配一个即可
      client_secret: COMMON_ENV.CLIENT_ID,
      grant_type: 'authorization_code', // 固定取值authorization_code
      redirect_uri: window.localStorage.getItem('REDIRECT_URI'), // 重定向地址,跟登录重定向地址保持一致
      code: params.code // 登录成功后，重定向回来的页面url中获取
    }
    return axios.post(url, formData)
  },

  // 根据token获取用户信息
  getUserInfoByToken(params) {
    const url = '/feign/getUserInfoByToken'
    return axios.post(BASE_URL + url, params)
  },
  // 获取分类
  getCategoryList(params) {
    const url = '/category/getCategoryList'
    return axios.post(BASE_URL + url, params)
  },
  // 搜索
  search(params) {
    const url = '/search/page'
    return axios.post(BASE_URL + url, params)
  },
  // 统计
  searchCount(params) {
    const url = '/search/count'
    return axios.post(BASE_URL + url, params)
  },
  // 获取分支机构信息
  getDistributorId(params) {
    const url = '/feign/getEntInfoByDomain'
    return axios.post(BASE_URL + url, params)
  },
  // 获取焦点图
  getBanner(params) {
    const url = '/focusmap/listFocusMap'
    return axios.post(BASE_URL + url, params)
  },
  // 获取首页前6个关键词
  getListKeywordTop(params) {
    const url = '/hotSearch/list'
    return axios.get(BASE_URL + url, params)
  },
  // 获取彩块推荐
  getHomeList(params) {
    const url = '/colorBlock/list'
    return axios.get(BASE_URL + url, { params })
  },
  // 获取法规列表数据
  getRegulationList(params) {
    const url = '/regulation/list'
    return axios.get(BASE_URL + url, { params })
  },
  // 获取解读+实务列表数据
  getPracticeList(params) {
    const url = '/practice/list'
    return axios.get(BASE_URL + url, { params })
  },
  // 获取案例列表数据
  getCaseList(params) {
    const url = '/case/list'
    return axios.get(BASE_URL + url, { params })
  },
  // 获取首页资讯-热门搜索
  getHotInfo(params) {
    const url = '/hotspot/list'
    return axios.get(BASE_URL + url, { params })
  },
  // 获取热门专题
  getHotTopic(params) {
    const url = '/topic/list'
    return axios.get(BASE_URL + url, { params })
  },
  // 获取法规详情
  getRegulationDetail(params) {
    const url = '/regulation/'
    return axios.get(BASE_URL + url + params.id)
  },
  // 获取法规注释
  getRegulationDetailNote(params) {
    const url = '/note/getSysNote'
    return axios.post(BASE_URL + url, params)
  },
  // 获取法规word
  getRegulationWord(params) {
    const url = '/file/downloadWord'
    return axios.get(BASE_URL + url, { responseType: 'blob', params, isHideLoading: true })
  },
  // 获取法规PDF
  getRegulationPDF(params) {
    const url = '/file/downloadPdf'
    return axios.get(BASE_URL + url, { responseType: 'blob', params, isHideLoading: true })
  },
  // 获取法规附件列表
  getFileListByRegId(params) {
    const url = '/file/getFileListByRegId'
    return axios.post(BASE_URL + url, params)
  },
  // 下载附件
  downloadFile(id) {
    const url = '/file/downloadFile'
    let param = '?id='
    return BASE_URL + url + param + id
  },
  // 获取解读+实务详情
  getPracticeDetail(params) {
    const url = '/practice/'
    return axios.get(BASE_URL + url + params.id)
  },
  // 获取案例详情
  getCaseDetail(params) {
    const url = '/case/'
    return axios.get(BASE_URL + url + params.id)
  },
  // 获取资讯列表
  getInfoList(params) {
    const url = '/information/page'
    return axios.post(BASE_URL + url, params)
  },
  // 获取热门资讯
  getMonthTopInfo(params) {
    const url = '/information/list'
    return axios.get(BASE_URL + url, { params })
  },
  // 获取资讯详情
  getInfoDetail(params) {
    const url = '/information/'
    return axios.get(`${BASE_URL + url + params.distributorId}/${params.id}`)
  },
  // 获取专题列表
  getTopicList(params) {
    const url = '/topic/page'
    return axios.post(BASE_URL + url, params)
  },
  // 获取专题详情
  getTopicDetail(params) {
    const url = '/topic/'
    return axios.get(`${BASE_URL + url + params.distributorId}/${params.id}`)
  },
  // 专题访问量记录
  countTopicBrowse(params) {
    const url = '/topic/insertTopicBrowse'
    return axios.post(BASE_URL + url, params)
  },
  // 获取关联列表
  getRelationList(params) {
    const url = '/regulation/getRelationList'
    return axios.get(BASE_URL + url, { params })
  },
  // 获取法规收藏列表
  getRegCollectionList(params) {
    const url = '/regulation/collections'
    return axios.post(BASE_URL + url, params)
  },
  // 获取解读+实务收藏列表
  getPraCollectionList(params) {
    const url = '/practice/collections'
    return axios.post(BASE_URL + url, params)
  },
  // 获取案例收藏列表
  getCaseCollectionList(params) {
    const url = '/case/collections'
    return axios.post(BASE_URL + url, params)
  },
  // 获取资讯收藏列表
  getInfoCollectionList(params) {
    const url = '/information/collections'
    return axios.post(BASE_URL + url, params)
  },
  // 获取收藏信息
  getCollectionInfo(params) {
    const url = '/collection/getCollection'
    return axios.post(BASE_URL + url, params)
  },
  // 根据id 收藏
  saveCollectionById(params) {
    const url = '/collection/addCollection'
    return axios.post(BASE_URL + url, params)
  },
  // 根据id 取消收藏
  cancelCollectionById(params) {
    const url = '/collection/cancelCollection'
    return axios.post(BASE_URL + url, params)
  },
  // 是否存在专家
  existingExperts(param) {
    // const url = '/home/existingExperts'
    let params = Object.assign(param, {
      productId: COMMON_ENV.expert_product_id,
      type: 6
    })
    return axios.get('/fatsapi/aosp-portal-center/product/getProductStatusByProductId', { params })
  },
  // 获取未读消息
  getUnreadMsgCount(params) {
    const url = `/fatsapi/fats-expert/login-expert/getUnreadMsgCount/${params.type}/${params.userId}`
    return axios.get(url, { isHideLoading: true })
  },
  // 获取搜索页面顶部分类
  getSearchList() {
    const url = '/category/getSearchList'
    return axios.get(BASE_URL + url)
  },
  // 判断该渠道是否需要新开页面
  getOpenType(params) {
    const url = '/distributor/getOpenType'
    return axios.get(BASE_URL + url, { params })
  }
}
